<h1>Contracts</h1>

<div class="actionwrapper">
  <div class="actions">
    <button mat-raised-button color="primary" (click)="applyMetadataTemplate()">
      <mat-icon>data_object</mat-icon>
      Apply Metadata Template
    </button>
    <button mat-raised-button color="primary" (click)="addItem()">
      <mat-icon>add</mat-icon>
      Add New Contract
    </button>
  </div>
</div>

<table class="table" mat-table matSort [dataSource]="items">
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
    <td class="cell" mat-cell *matCellDef="let item">{{item.name || '-'}}</td>
  </ng-container>

  <ng-container matColumnDef="ownerUserId">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Owner User ID</th>
    <td class="cell" mat-cell *matCellDef="let item">{{item.ownerUserId || '-'}}</td>
  </ng-container>

  <ng-container matColumnDef="contractType">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
    <td class="cell" mat-cell *matCellDef="let item">{{item.contractType || '-'}}</td>
  </ng-container>

  <ng-container matColumnDef="counterpartyType">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Counterparty Type</th>
    <td class="cell" mat-cell *matCellDef="let item">{{item.counterpartyType || '-'}}</td>
  </ng-container>

  <ng-container matColumnDef="counterpartyId">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Counterparty ID</th>
    <td class="cell" mat-cell *matCellDef="let item">{{item.counterpartyId || '-'}}</td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
    <td class="cell" mat-cell *matCellDef="let item">{{item.status || '-'}}</td>
  </ng-container>

  <ng-container matColumnDef="actionmenu" stickyEnd>
    <th mat-header-cell matTooltip="Actions" *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let item">
      <button mat-button class="cell" [matMenuTriggerFor]="menu" [matMenuTriggerData]="{item: item}">
        <mat-icon matTooltip="Actions" class="more">more_vert</mat-icon>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="allColumnNames"></tr>
  <tr class="listitem" mat-row *matRowDef="let rows; columns: allColumnNames"></tr>

  <mat-menu #menu="matMenu">
    <ng-template matMenuContent let-item="item">
      <button mat-menu-item (click)="editItem(item)">Edit</button>
      <button mat-menu-item (click)="applyMetadataTemplate(item)">Apply Metadata Template</button>
      <button mat-menu-item (click)="viewReportConfig(item)">View Report Config</button>
      <button mat-menu-item (click)="deleteItem(item)">End Contract</button>
    </ng-template>
  </mat-menu>
</table>
